/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

import React from "react";
import {
    Button,
    Form,
    FormGroup,
    Grid,
    Header,
    Image,
    Message,
    Segment,
} from "semantic-ui-react";

const FirstStepLogin = ({
    isDarkTheme,
    credentials,
    error,
    handleChange,
    clickLoginButton,
    isKeycloak,
}) => (
    <Grid
        className={isDarkTheme ? "login-dark" : "login-light"}
        textAlign="center"
        style={{ height: "100vh", margin: 0 }}
        verticalAlign="middle"
    >
        <Grid.Column style={{ maxWidth: 550 }}>
            <Image src="/static/logo.png" centered alt="" />
            <Header as="h2" color="blue" textAlign="center">
                Log-in to your account
            </Header>
            <Form size="large">
                <Segment stacked>
                    <Form.Input
                        fluid
                        icon="user"
                        iconPosition="left"
                        placeholder="Login"
                        name="login"
                        value={credentials.login}
                        onChange={handleChange}
                        error={error.login}
                    />
                    <Form.Input
                        fluid
                        icon="lock"
                        iconPosition="left"
                        placeholder="Password"
                        type="password"
                        name="password"
                        value={credentials.password}
                        onChange={handleChange}
                        error={error.password}
                    />

                    <FormGroup>
                        <Button
                            color="blue"
                            fluid
                            size="large"
                            onClick={clickLoginButton}
                        >
                            Login
                        </Button>

                        {isKeycloak && (
                            <Button
                                as="a"
                                href={`/auth/login/keycloak/`}
                                target="_blank"
                                color="grey"
                                fluid
                                size="large"
                            >
                                Login with Keycloak
                            </Button>
                        )}
                    </FormGroup>
                    <div style={{ marginTop: "5px" }}>
                        <a href={"/auth/password-reset/"}>Forgot password?</a>
                    </div>
                </Segment>
            </Form>
            {/* <Message>
						<Link to={'/registration'}>Registration</Link>
					</Message> */}
            {error.wrongCredentials ? (
                <Message negative>
                    <p>{error.apiMessage}</p>
                </Message>
            ) : null}
        </Grid.Column>
    </Grid>
);

export default FirstStepLogin;
